import { notification } from '@pu/mpp-ui/notifications';
import { ICreateShortcutRequest } from 'core/model/interfaces/shortcuts/shortcuts-form.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { SLICE_NAMESPACE } from '../shortcuts.constants';
import { IShortcutsState } from '../shortcuts.types';
import { fetchShortcuts } from './fetchShortcuts';

export const createShortcut = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/createShortcut`,
  async (data: ICreateShortcutRequest, { dispatch }) => {
    try {
      await apiService.shortcuts.createShortcut(data);

      notification.success('Shortcut creado correctamente.');

      await dispatch(fetchShortcuts());
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Ocurrió un error al crear el shortcut.');

      showNotificationError(errorMessage);
      throw error;
    }
  },
);

export const createShortcutReducer: TSliceExtraReducer<IShortcutsState> = builder =>
  builder
    .addCase(createShortcut.pending, state => {
      state.form.isLoading = true;
      state.form.isSuccess = false;
    })
    .addCase(createShortcut.rejected, state => {
      state.form.isLoading = false;
      state.form.isSuccess = false;
    })
    .addCase(createShortcut.fulfilled, state => {
      state.form.isLoading = false;
      state.form.isSuccess = true;
    });
